import './Ellipsis.scss';

export const Ellipsis = () => (
  <span className="dots">
    <span className="dot"></span>
    <span className="dot"></span>
    <span className="dot"></span>
  </span>
);
